import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NegotiationsService } from 'src/app/services/negotiations.service';

@Component({
  selector: 'app-negotiations-counter',
  templateUrl: './negotiations-counter.component.html',
  styleUrls: ['./negotiations-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NegotiationsCounterComponent {
  @Input() offset: [number, number] = [0, 0];

  readonly hasNegotiations$: Observable<boolean>;

  constructor(negotiationsService: NegotiationsService) {
    this.hasNegotiations$ = negotiationsService.hasNegotiations$;
  }
}
